import { Injectable } from '@angular/core';
import {Crud} from './crud';
import {Observable} from 'rxjs';
import {AngularFirestore, AngularFirestoreCollection} from '@angular/fire/firestore';
import {AngularFireAuth} from '@angular/fire/auth';
import {map, take} from 'rxjs/operators';
import {AngularFireStorage} from '@angular/fire/storage';
import {Image} from '../../../../../models/image/image';
import * as firebase from 'firebase';
import {NavigationExtras, Router} from '@angular/router';
import {AlertController, LoadingController, ToastController} from '@ionic/angular';
import { resolve } from 'url';
import { MyEvent } from 'src/services/myevent.services';
import { Status } from 'src/models/public-collective/appointment/appointment';
import { AccountModel } from 'src/models/accounts/account';
import { TranslateService } from '@ngx-translate/core';

function firebaseSerialize<T>(object: T) {
  return JSON.parse(JSON.stringify(object));
}



@Injectable({
  providedIn: 'root'
})
export class CrudService<T, MyType> implements Crud<T, MyType> {
  private imageCollection: AngularFirestoreCollection<Image>;
  images: Observable<Image[]>;
  isLoading = false;
  functions: any;
  addAdmin: any;
  addExpert: any;
  addPatient: any;
  confirmExpert: any;
  reConfirmExpert: any;

  constructor(
      private firestore: AngularFirestore,
      private afAuth: AngularFireAuth,
      private storage: AngularFireStorage,
      private router: Router,
      private loadingCtrl: LoadingController,
      private alertCtrl: AlertController,
      private toastController: ToastController,
      private translate: TranslateService
  ) {
    this.functions = firebase.functions();
    this.addAdmin = this.functions.httpsCallable('addAdminRole');
    this.addExpert = this.functions.httpsCallable('addExpertRole');
    this.addPatient = this.functions.httpsCallable('addSubscriberRole');
    this.confirmExpert = this.functions.httpsCallable('confirmExpert');
    this.reConfirmExpert = this.functions.httpsCallable('reConfirmExpert');
  }
  deleteRow(fireString: string, uid: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.firestore.doc(fireString).delete().then(() => {
        resolve(true);
      }).catch(error => {
        reject(error);
      });
    });
  }
  deleteRecord(record_id: string, fireString: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.firestore.doc(fireString + '/' + record_id).delete().then(resDel => {
        resolve(true);
      }).catch(errDel => {
        reject(errDel);
      });
    });
  }

  save(model: T, fireString: string, uid: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString).doc(uid).set(Object.assign({}, model)).then(() => {
        resolve(true);
      }).catch(err => {
        reject(err);
      });
    });
  }


  saveNewRef(model: T, fireString: string, uid: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString).add(Object.assign({}, model)).then(() => {
        resolve(true);
      }).catch(err => {
        reject(err);
      });
    });
  }

  saveNewRefReturnId(model: T, fireString: string, uid: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString).add(Object.assign({}, model)).then(res => {
        resolve(res.id);
      }).catch(err => {
        reject(err);
      });
    });
  }

  addSubCollectionToDoc(model: T, fireString: string, subColName: string , uid: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString).doc(uid).ref.collection(subColName).add(Object.assign({}, model)).then(() => {
        resolve(true);
      }).catch((err) => {
        reject(err);
      });
    });
  }
  addSubCollectionToDocByPath(model: T, path: string, uid: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(path).add(Object.assign({}, model)).then(() => {
        resolve(true);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  addSubCollectionToDocOneToOne(model: T, fireString: string, subColName: string , uid: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString).doc(uid).collection(subColName).doc(uid).set(Object.assign({}, model)).then(() => {
        resolve(true);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  checkCollectionExist(path: string): Promise<boolean> {
    console.log(path);

    return new Promise((resolve, reject) => {
      this.firestore.doc(path).get().toPromise().then((querySnapshot) => {
        console.log('girdi');

        resolve(true);
        }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }


  updateWithUid(model: T, fireString: string, uid: string): Promise<T> {
    return new Promise((resolve, reject) => {
      this.firestore.doc(fireString + '/' + uid).update(model).then(() => {
        resolve(model);
      }).catch(err => {
        reject(err);
      });
    });
  }

  updateWithColId(id: string, model: T, fireString: string, uid: string): Promise<T> {
    return new Promise((resolve, reject) => {
      this.firestore.doc(fireString + '/' + id).update(model).then(() => {
        resolve(model);
      }).catch(err => {
        reject(err);
      });
    });
  }

  updateWithPath(model: T, id: string, uid: string): Promise<T> { // id => fullpath
    return new Promise((resolve, reject) => {
      this.firestore.doc(id).update(model).then(() => {
        resolve(model);
      }).catch(err => {
        reject(err);
      });
    });
  }

  findAllPublic(model: T, fireString: string): Observable<MyType[]> {
    const collection = this.firestore.collection(fireString);
    return collection.snapshotChanges().pipe(
        // Again we want to build a Typed JS Object from the Document
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as MyType;
            // @ts-ignore
            data.id = a.payload.doc.id;
            return data;
          });
        })
    );
  }

  findAllPublicGroup(fireString: string): Promise<MyType[]> {
    return new Promise<MyType[]>((resolve, reject) => {
      const data = [] as MyType[];
      this.firestore.collectionGroup('interestsForQuestions', ref => ref.where('accounts', '==', 'VB3s28RlmQQ1kGKh3DGLXAP7Oal2').where('profile', '==', 'VB3s28RlmQQ1kGKh3DGLXAP7Oal2')).get().toPromise().then(res => {
        res.docs.forEach((item) => {
          data.push(item.data() as MyType);
        });
        resolve(data);
      }).catch(err => {
        reject(err);
      });
    });
  }

  findAllPublicGroupThreeLayerQueryIn(fireString: string, refName: string, queryRef: any, refNameTwo: string, queryRefTwo: any, refNameThree: string, queryRefThree: any): Observable<{obj: MyType, ref: string}[]> {
    const sonuc = [] as {obj: MyType, ref: string}[];
    return this.firestore.collectionGroup(fireString, ref => ref.where(refName, '==', queryRef).where(refNameTwo, 'in', queryRefTwo)).snapshotChanges().pipe(
      map(changes => {
      return changes.map(a => {
        return {obj: a.payload.doc.data() as MyType, ref: a.payload.doc.id};
      });
    }));
  }
  findAllPublicThreeLayerQueryIn(fireString: string, refName: string, queryRef: any, refNameTwo: string, queryRefTwo: any, refNameThree: string, queryRefThree: any): Observable<{obj: MyType, ref: string}[]> {
    const sonuc = [] as {obj: MyType, ref: string}[];
    return this.firestore.collectionGroup(fireString, ref => ref.where(refName, '==', queryRef).where(refNameTwo, 'in', queryRefTwo).where(refNameThree, '==', queryRefThree)).snapshotChanges().pipe(
      map(changes => {
      return changes.map(a => {
        return {obj: a.payload.doc.data() as MyType, ref: a.payload.doc.id};
      });
    }));
  }

  findAllPublicTwoLayerQueryIn(fireString: string, refName: string, queryRef: any, refNameTwo: string, queryRefTwo: any): Observable<{obj: MyType, ref: string}[]> {
    const sonuc = [] as {obj: MyType, ref: string}[];
    return this.firestore.collection(fireString, ref => ref.where(refName, '==', queryRef).where(refNameTwo, 'in', queryRefTwo)).snapshotChanges().pipe(
      map(changes => {
      return changes.map(a => {
        return {obj: a.payload.doc.data() as MyType, ref: a.payload.doc.id};
      });
    }));
  }

  findAllPublicTwoLayerOrCondition(fireString: string, refName: string, queryRef: any, refNameTwo: string, queryRefTwo: any): Observable<{obj: MyType, ref: string}[]> {
    return this.firestore.collection(fireString, ref => ref.where(refName, 'in', queryRef).where(refNameTwo, '==', queryRefTwo)).snapshotChanges().pipe(
      map(changes => {
      return changes.map(a => {
        return {obj: a.payload.doc.data() as MyType, ref: a.payload.doc.id};
      });
    }));
  }

  findAllPublicThreeLayerOrCondition(fireString: string, refName: string, queryRef: any, refNameTwo: string, queryRefTwo: any, refNameThree: string, queryRefThree: any): Observable<{obj: MyType, ref: string}[]> {
    return this.firestore.collection(fireString, ref => ref.where(refName, 'in', queryRef).where(refNameTwo, '==', queryRefTwo).where(refNameThree, '==', queryRefThree)).snapshotChanges().pipe(
      map(changes => {
      return changes.map(a => {
        return {obj: a.payload.doc.data() as MyType, ref: a.payload.doc.id};
      });
    }));
  }


/*   findAllPublicTwoLayerOrCondition(fireString: string,refName: string, queryRef: string, refNameTwo: string, queryRefTwo: string) :Observable<{obj: MyType, ref: string}[]> {
   // "state", "==", "CA", "||", "state", "==", "AZ"
    return this.firestore.collection(fireString, ref=> ref.where(refName, '==',queryRef, '||', refNameTwo, '==',queryRefTwo)).snapshotChanges().pipe(
      map(changes => {
      return changes.map(a => {
        return {obj: a.payload.doc.data() as MyType, ref: a.payload.doc.id};
      });
    }));
  } */

  findAllPublicOneLayerQueryIn(fireString: string, refName: string, queryRef: any): Observable<{obj: MyType, ref: string}[]> {
    const sonuc = [] as {obj: MyType, ref: string}[];
    return this.firestore.collection(fireString, ref => ref.where(refName, 'in', queryRef)).snapshotChanges().pipe(
      map(changes => {
      return changes.map(a => {
        return {obj: a.payload.doc.data() as MyType, ref: a.payload.doc.id};
      });
    }));
  }

  findAllPublicGroupThreeLayerQueryEqual(fireString: string, refName: string, queryRef: any, refNameTwo: string, queryRefTwo: any): Observable<MyType[]> {
    return this.firestore.collectionGroup(fireString, ref => ref.where(refName, '==', queryRef).where(refNameTwo, '==', queryRefTwo)).snapshotChanges().pipe(
      map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as MyType;
        // @ts-ignore
        data.id = a.payload.doc.id;
        return data;
      });
    }));
  }

  findAllPublicGroupOneLayerQuery(fireString: string, refName: string, queryRef: any): Observable<MyType[]> {
    return this.firestore.collectionGroup(fireString, ref => ref.where(refName, '==', queryRef)).snapshotChanges().pipe(
      map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as MyType;
        // @ts-ignore
        data.id = a.payload.doc.id;
        return data;
      });
    }));
  }



  findAllPublicPromiseGroupOneLayerQuery(fireString: string, refName: string, queryRef: any): Promise<MyType[]> {
    return new Promise((resolve, reject) => {
      const data  = [] as MyType[];
      this.firestore.collectionGroup(fireString, ref => ref.where(refName, '==', queryRef)).get().toPromise().then(res => {
        res.forEach(((item) => {
          data.push(item.data() as MyType);
        }));
        resolve(data);
      }).catch(err => {
        reject(err);
      });
    });
  }

  findAllPublicPromise(fireString: string): Promise<MyType[]> {
    const x = {} as MyType[];
    const i = 0;
    const a = [];
    return new Promise<MyType[]>((resolve, reject) => {
      this.firestore.collection(fireString).get().toPromise().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());

         // x[i] = (doc.data() as MyType);
          // i++;
          // xmodel.push(doc.data() as MyType);
          a.push((doc.data() as MyType));
        });
        console.log(a);
        resolve(a);
      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }

  findAllPublicPromiseWithId(fireString: string): Promise<{name: string, ref: string}[]> {
    const x = {} as MyType[];
    const i = 0;
    const a = [];
    const sonuc = [] as {name: string, ref: string}[];
    return new Promise<{name: string, ref: string}[]>((resolve, reject) => {
      this.firestore.collection(fireString).get().toPromise().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());
         // x[i] = (doc.data() as MyType);
          // i++;
          // xmodel.push(doc.data() as MyType);
          // a.push((doc.data() as MyType),doc.id);
          sonuc.push({name: doc.data().title, ref: doc.id});
        });
        console.log(sonuc);
        resolve(sonuc);
      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }

  findAllPublicPromiseWithIdReturnObj(fireString: string): Promise<{obj: MyType, ref: string}[]> {

    const sonuc = [] as {obj: MyType, ref: string}[];
    return new Promise<{obj: MyType, ref: string}[]>((resolve, reject) => {
      this.firestore.collection(fireString).get().toPromise().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());
          sonuc.push({obj: (doc.data() as MyType), ref: doc.id});
        });
        console.log(sonuc);
        resolve(sonuc);
      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }

  findAllPublicPromiseOneLayerQuery(fireString: string, refName: string, queryRef: any): Promise<MyType[]> {

    const sonuc = [] as MyType[];
    return new Promise<MyType[]>((resolve, reject) => {
      this.firestore.collection(fireString, ref => ref.where(refName, '==', queryRef)).get().toPromise().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());
          sonuc.push((doc.data() as MyType));
        });
        console.log(sonuc);
        resolve(sonuc);
      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }

  findAllPublicPromiseThreeLayerQuery(fireString: string, refName: string, queryRef: any, refNameTwo: string, queryRefTwo: any, refNameThree: string, queryRefThree: any): Promise<{obj: MyType, ref: string}[]> {

    const sonuc = [] as {obj: MyType, ref: string}[];
    return new Promise<{obj: MyType, ref: string}[]>((resolve, reject) => {
      this.firestore.collection(fireString, ref => ref.where(refName, '==', queryRef).where(refNameTwo, '==', queryRefTwo).where(refNameThree, '==', queryRefThree)).get().toPromise().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());
          sonuc.push({obj: doc.data() as MyType, ref: doc.id});
        });
        console.log(sonuc);
        resolve(sonuc);
      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }

  findAllPublicPromiseWithIdReturnObjOrderBy(fireString: string): Promise<{obj: MyType, ref: string}[]> {

    const sonuc = [] as {obj: MyType, ref: string}[];
    return new Promise<{obj: MyType, ref: string}[]>((resolve, reject) => {
      this.firestore.collection(fireString, ref => ref.orderBy('date', 'asc')).get().toPromise().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());
          sonuc.push({obj: (doc.data() as MyType), ref: doc.id});
        });
        console.log(sonuc);
        resolve(sonuc);
      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }

  findAllPublicPromiseWithIdReturnObjOrderByAndQuery(fireString: string, refName: string, queryRef: any): Promise<{obj: MyType, ref: string}[]> {

    const sonuc = [] as {obj: MyType, ref: string}[];
    return new Promise<{obj: MyType, ref: string}[]>((resolve, reject) => {
      this.firestore.collection(fireString, ref => ref.where(refName, '==', queryRef).orderBy('date', 'asc')).get().toPromise().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());
          sonuc.push({obj: (doc.data() as MyType), ref: doc.id});
        });
        console.log(sonuc);
        resolve(sonuc);
      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }


  findAllPublicPromiseWithRefAndIdReturnObj(fireString: string): Promise<{obj: MyType, ref: string}[]> {

    const sonuc = [] as {obj: MyType, ref: string}[];
    return new Promise<{obj: MyType, ref: string}[]>((resolve, reject) => {
      this.firestore.collection(fireString).get().toPromise().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());
          sonuc.push({obj: doc.data() as MyType, ref: doc.id});
        });
        console.log(sonuc);
        resolve(sonuc);
      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }


  findOnePublic(id: string, fireString: string): Observable<MyType> {
    const collection = this.firestore.collection(fireString);
    return collection
        .doc<MyType>(id)
        .snapshotChanges()
        .pipe(
            // We want to map the document into a Typed JS Object
            map(doc => {
              console.log(doc);
              // Only if the entity exists should we build an object out of it
              if (doc.payload.exists) {
                const data = doc.payload.data() as MyType;
                const payloadId = doc.payload.id;
                return { id: payloadId, ...data };
              }
            })
        );
  }

  findOnePublicPromise(id: string, fireString: string): Promise<MyType> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString).doc<MyType>(id).get().toPromise().then(r => {
        resolve(r.data() as MyType);
      }).catch(err => {
        reject(err);
      });
    });
  }

  findOnePublicPromiseLastIndex(fireString: string, query: string): Promise<MyType> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString, ref => ref.orderBy(query, 'desc').limit(1)).get().toPromise().then(r => {
        r.forEach((item => {
          resolve(item.data() as MyType);
        }));
      }).catch(err => {
        reject(err);
      });
    });
  }
  findOnePublicPromiseLastIndexWithId(fireString: string, query: string): Promise<{obj: MyType, ref: string}> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString, ref => ref.orderBy(query, 'desc').limit(1)).get().toPromise().then(r => {
        r.forEach((item => {
          resolve({obj: item.data() as MyType, ref: item.id});
        }));
      }).catch(err => {
        reject(err);
      });
    });
  }

  findAll(fireString: string, uid: string): Observable<MyType[]> {
    const collection = this.firestore.collection(fireString);
    return collection.snapshotChanges().pipe(
        // Again we want to build a Typed JS Object from the Document
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as MyType;
            // @ts-ignore
            data.id = a.payload.doc.id;
            return data;
          });
        })
    );
  }

  findAllPromise(fireString: string, uid: string, checkUser: boolean): Promise<MyType[]> {
    const x = {} as MyType[];
    let i = 0;
    return new Promise<MyType[]>((resolve, reject) => {
      this.firestore.collection(fireString).get().toPromise().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());
          x[i] = (doc.data() as MyType);
          i++;
          // xmodel.push(doc.data() as MyType);
        });
        console.log(x);
        resolve(x);
      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }

  findAllPromiseWithDocumentReference(fireString: string, uid: string, checkUser: boolean): Promise<{name: string, ref: string}[]> {
      const sonuc = [] as {name: string, ref: string}[];
      return new Promise<{name: string, ref: string}[]>((resolve, reject) => {
      this.firestore.collection(fireString).get().toPromise().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());
          sonuc.push({name: doc.data().name, ref: doc.id});
        });
        console.log(sonuc);
        resolve(sonuc);
      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }

  findFirstRefPromise(fireString: string, id: string, subCol: string): Promise<{obj: MyType, refId: string}> {
      return new Promise<{obj: MyType, refId: string}>((resolve, reject) => {
      return this.firestore.collection(fireString).doc<MyType>(id).collection(subCol).get().toPromise().then((querySnapshot) => {
        if (querySnapshot && querySnapshot.docs && querySnapshot.docs.length > 0) {
          let resData: MyType;
          resData = querySnapshot.docs[0].data() as MyType;
          const refId: string = querySnapshot.docs[0].id;
          resolve({obj: resData, refId});
        } else {
          resolve(null);
        }

      }).catch(err => {
        console.log(err);
        reject(err);
      });
    });
  }

  findOne(id: string, fireString: string, uid: string): Observable<MyType> {
    const collection = this.firestore.collection(fireString);
    return collection
        .doc<MyType>(id)
        .snapshotChanges()
        .pipe(
            // We want to map the document into a Typed JS Object
            map(doc => {
              console.log(doc);
              // Only if the entity exists should we build an object out of it
              if (doc.payload.exists) {
                const data = doc.payload.data() as MyType;
                const payloadId = doc.payload.id;
                return { id: payloadId, ...data };
              }
            })
        );
  }

  findOnePromise(id: string, fireString: string, uid: string, checkUser: boolean): Promise<MyType> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString).doc<MyType>(id).get().toPromise().then(r => {
        resolve(r.data() as MyType);
      }).catch(err => {
        reject(err);
      });
    });
  }

  findOnePromiseWithDataRef(id: string, fireString: string): Promise<{ref: firebase.firestore.DocumentReference}> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString).doc<MyType>(id).get().toPromise().then(r => {
        resolve({ref: r.ref});
      }).catch(err => {
        reject(err);
      });
    });
  }

  findOnePromiseByQueryWithId(fireString: string, refName: string, refQuery: string): Promise<{obj: MyType, id: string}> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString, ref => ref.where(refName, '==', refQuery).limit(1)).get().toPromise().then(r => {
        resolve({obj: r.docs[0].data() as MyType, id: r.docs[0].id});
      }).catch(err => {
        reject(err);
      });
    });
  }

  findOnePromiseThirdLayerQueryWithId(layerOne: string, idOne: string, layerTwo: string, idTwo: string, layerThree: string, refValue: string, query: any): Promise<{obj: MyType, id: string}> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(layerOne).doc(idOne).collection(layerTwo).doc(idTwo).collection(layerThree, ref => ref.where(refValue, '==', query)).get().toPromise().then(res => {
        resolve({obj: res.docs[0].data() as MyType, id: res.docs[0].id});
      }).catch(err => {
        reject(err);
      });
    });

  }

  findOnePromiseQuadLayerQueryWithId(layerOne: string, idOne: string, layerTwo: string, idTwo: string, layerThree: string, idThree: string, layerFour: string, refValue: string, query: any): Promise<{obj: MyType, id: string}> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(layerOne).doc(idOne).collection(layerTwo).doc(idTwo).collection(layerThree).doc(idThree).collection(layerFour, ref => ref.where(refValue, '==', query)).get().toPromise().then(res => {
        console.log(res);

        resolve({obj: res.docs[0].data() as MyType, id: res.docs[0].id});
      }).catch(err => {
        reject(err);
      });
    });

  }



  findOnePromiseByPath(fireString: string): Promise<MyType> {
    return new Promise((resolve, reject) => {
      this.firestore.doc<MyType>(fireString).get().toPromise().then(r => {
        resolve(r.data() as MyType);
      }).catch(err => {
        reject(err);
      });
    });
  }

  findOnePromiseByPathWithDataRef(fireString: string): Promise<{ref: firebase.firestore.DocumentReference}> {
    return new Promise((resolve, reject) => {
      this.firestore.doc<MyType>(fireString).get().toPromise().then(r => {
        resolve({ref: r.ref});
      }).catch(err => {
        reject(err);
      });
    });
  }

  findAllPromiseByQuery(refName: string, collectionName: string, queryRef: string ): Promise<MyType[]> {
    const x = {} as MyType[];
    const a = [];
    let i = 0;
    return new Promise<MyType[]>((resolve, reject) => {
      this.firestore.collection<MyType>(collectionName, ref => ref.where(refName, '==', queryRef)).get().toPromise().then(res => {
        res.forEach((doc) => {
          a.push((doc.data() as MyType));
          i++;
          });
        resolve(a);
      }).catch(err => {
         console.log(err);
         reject(err);
       });
    });
  }

  findAllPromiseByBoolQuery(refName: string, collectionName: string, queryRef: boolean, refNameTwo: string, queryRefTwo: boolean ): Promise<MyType[]> {
    const x = {} as MyType[];
    const a = [];
    let i = 0;
    return new Promise<MyType[]>((resolve, reject) => {
      this.firestore.collection<MyType>(collectionName, ref => ref.where(refName, '==', queryRef).where(refNameTwo, '==', queryRefTwo)).get().toPromise().then(res => {
        res.forEach((doc) => {
          a.push((doc.data() as MyType));
          i++;
          });
        resolve(a);
      }).catch(err => {
         console.log(err);
         reject(err);
       });
    });
  }


  findAllPromiseByBoolQueryReturnWithReferance(refName: string, collectionName: string, queryRef: boolean, refNameTwo: string, queryRefTwo: boolean ): Promise<{obj: AccountModel, ref: firebase.firestore.DocumentReference}[]> {
    const x = {} as MyType[];
    const a = [] as {obj: AccountModel, ref: firebase.firestore.DocumentReference}[];
    const i = 0;
    return new Promise<{obj: AccountModel, ref: firebase.firestore.DocumentReference}[]>((resolve, reject) => {
      this.firestore.collection<AccountModel>(collectionName, ref => ref.where(refName, '==', queryRef).where(refNameTwo, '==', queryRefTwo)).get().toPromise().then(res => {
        res.forEach((doc) => {
          this.firestore.collection('accounts').doc(doc.ref.id).collection('profile').get().toPromise().then(resRef => {
            if (resRef && resRef.docs && resRef.docs.length > 0) {
              a.push({obj: doc.data() as AccountModel, ref: resRef.docs[0].ref });
            }
          }).catch(errRef => {
            console.log(errRef);
          });
          });
        resolve(a);
      }).catch(err => {
         console.log(err);
         reject(err);
       });
    });
  }



  findAllPromiseObjRefWhereOrderBy(collectionName: string, refName: string,  queryRef: any, orderRef: string, orderVal: any ): Promise<{obj: MyType, ref: string}[]> {

    const sonuc = [] as {obj: MyType, ref: string}[];
    return new Promise<{obj: MyType, ref: string}[]>((resolve, reject) => {
      this.firestore.collection<MyType>(collectionName, ref => ref.where(refName, '==', queryRef).orderBy(orderRef, orderVal)).get().toPromise().then(res => {
        res.forEach((doc) => {
          sonuc.push({obj: doc.data() as MyType, ref: doc.id});
          });
        resolve(sonuc);
      }).catch(err => {
         console.log(err);
         reject(err);
       });
    });
  }

  findAllPromiseObjRefWhereOrderByTwoLayer(collectionName: string, refName: string,  queryRef: any, refNameTwo: string , queryRefTwo: any, orderRef: string, orderVal: any ): Promise<{obj: MyType, ref: string}[]> {

    const sonuc = [] as {obj: MyType, ref: string}[];
    return new Promise<{obj: MyType, ref: string}[]>((resolve, reject) => {
      this.firestore.collection<MyType>(collectionName, ref => ref.where(refName, '==', queryRef).orderBy(orderRef, orderVal)).get().toPromise().then(res => {
        res.forEach((doc) => {
          sonuc.push({obj: doc.data() as MyType, ref: doc.id});
          });
        resolve(sonuc);
      }).catch(err => {
         console.log(err);
         reject(err);
       });
    });
  }

  findAllPromiseObjRefWhereOrderByTwoLayerWithConditioins(collectionName: string, refName: string,  queryRef: any, condOne: any, refNameTwo: string , queryRefTwo: any, condTwo: any, orderRef: string, orderVal: any ): Promise<{obj: MyType, ref: string}[]> {

    const sonuc = [] as {obj: MyType, ref: string}[];
    return new Promise<{obj: MyType, ref: string}[]>((resolve, reject) => {
      this.firestore.collection<MyType>(collectionName, ref => ref.where(refName, '==', queryRef).orderBy(orderRef, orderVal)).get().toPromise().then(res => {
        res.forEach((doc) => {
          sonuc.push({obj: doc.data() as MyType, ref: doc.id});
          });
        resolve(sonuc);
      }).catch(err => {
         console.log(err);
         reject(err);
       });
    });
  }


  findAllPromiseWithIdByQuery(refName: string, collectionName: string, queryRef: firebase.firestore.DocumentReference ): Promise<{obj: MyType, ref: string}[]> {

    const sonuc = [] as {obj: MyType, ref: string}[];
    return new Promise<{obj: MyType, ref: string}[]>((resolve, reject) => {
      this.firestore.collection<MyType>(collectionName, ref => ref.where(refName, '==', queryRef)).get().toPromise().then(res => {
        res.forEach((doc) => {
          sonuc.push({obj: doc.data() as MyType, ref: doc.id});
          });
        resolve(sonuc);
      }).catch(err => {
         console.log(err);
         reject(err);
       });
    });
  }

  findAllPromiseWithIdByQueryTwoLayer(refName: string, collectionName: string, queryRef: firebase.firestore.DocumentReference, refNameTwo: string, queryRefTwo: any ): Promise<{obj: MyType, ref: string}[]> {

    const sonuc = [] as {obj: MyType, ref: string}[];
    return new Promise<{obj: MyType, ref: string}[]>((resolve, reject) => {
      this.firestore.collection<MyType>(collectionName, ref => ref.where(refName, '==', queryRef).where(refNameTwo, '==', queryRefTwo)).get().toPromise().then(res => {
        res.forEach((doc) => {
          sonuc.push({obj: doc.data() as MyType, ref: doc.id});
          });
        resolve(sonuc);
      }).catch(err => {
         console.log(err);
         reject(err);
       });
    });
  }



  addImageToCollectionBySub(image: Image, id: string, fireString: string): Promise<boolean> {
    // Create an ID for document
    // const id = this.firestore.createId();
    return new Promise( (resolve, reject) => {
      this.firestore.collection(fireString).doc(id).ref.collection('images').add(Object.assign({}, image)).then(() => {
        resolve(true);
      }).catch(error => {
        reject(error);
      });
    } );
  }

  addImageToCollectionBySubById(image: Image, id: string, fireString: string): Promise<boolean> {
    // Create an ID for document
    // const id = this.firestore.createId();
    return new Promise( (resolve, reject) => {
      this.firestore.collection(fireString).doc(id).collection('images').doc(id).set(Object.assign({}, image)).then(() => {
        resolve(true);
      }).catch(error => {
        reject(error);
      });
    } );
  }

  generateSingleImage(image: Image, fireString: string, id: string, uid: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        this.firestore.doc(fireString + '/' + id).update(image).then(doc => {
          resolve(true);
        }).catch(error => {
          reject(false);
        });
    });
  }

  getSingleImage(id: string, fireString: string, uid: string, checkedUser: boolean): Observable<Image>  {
    const collection = this.firestore.collection(fireString);

    return collection
        .doc<Image>(id)
        .snapshotChanges()
        .pipe(
            // We want to map the document into a Typed JS Object
            map(doc => {
              // Only if the entity exists should we build an object out of it
              if (doc.payload.exists) {
                const data = doc.payload.data() as Image;
                const payloadId = doc.payload.id;
                return { id: payloadId, ...data };
              }
            })
        );
  }

  getSingleImagePromise(id: string, fireString: string, uid: string, checkUser: boolean): Promise<Image>  {
    return new Promise((resolve, reject) => {
      this.firestore.collection(fireString).doc<Image>(id).get().toPromise().then(r => {
        resolve(r.data() as Image);
      }).catch(err => {
        reject(err);
      });
    });
  }

  deleteImageFromStorageWithRef(refUrl: string): Promise<boolean> {
    console.log(refUrl);
    return new Promise((resolve, reject) => {
      if (refUrl) {
        return this.storage.storage.refFromURL(refUrl).delete().then(() => {
          resolve(true);
        }).catch(error => {
          console.log(error);
          reject(false);
        });
      }
      reject(false);
    });


  }

  deleteImageFromDatabase(fireString: string, uid: string): Promise<boolean> { // by collection
    const collection = this.firestore.collection(fireString);
    return new Promise((resolve, reject) => {
      collection.doc(uid).set({
        ['imageFilepath']: firebase.firestore.FieldValue.delete(),
        ['imageName']: firebase.firestore.FieldValue.delete(),
        ['imageSize']: firebase.firestore.FieldValue.delete()

      }, { merge: true }).then(() => {
        resolve(true);
      }).catch(error => {
        reject(error);
      });
    });
  }

  getAllImages(fireString: string): Observable<Image[]> { // by collection
    this.imageCollection = this.firestore.collection<Image>('accounts');
    return this.imageCollection.valueChanges();
  }

  getAllImagesByDoc(fireString: string, id: string, uid: string): Observable<Image[]> { // by full url
    this.imageCollection = this.firestore.collection<Image>('accounts');
    return this.imageCollection.valueChanges();
  }

  SignIn(email: string, password: string): Promise<any> {

    return new Promise((resolve, reject) => {

      this.afAuth.signOut().then(resRes => {
        this.afAuth
        .signInWithEmailAndPassword(email, password)
        .then(res => {
          console.log('You are Successfully logged in!');
          console.log(res);
          resolve(res.user);
        })
        .catch(err => {
          console.log('Something is wrong:', err.message);
          reject(err.message);
        });
      });


    });
  }

  SignUp(email, password): Promise<any> {
    return new Promise((resolve, reject) => {
      this.afAuth.createUserWithEmailAndPassword(email, password)
          .then((result) => {
            console.log(result.user);
            resolve(result.user);
          }).catch((err) => {
        reject(err.message);
      });
    });

  }

  authenticate(emailData: string, password: string, name: string, surname: string, termsBool: boolean, isLogin: boolean, role: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      this.loadingCtrl
          .create({ keyboardClose: true, message: this.translate.instant('checking') })
          .then(loadingEl => {
            loadingEl.present().then();
            if (isLogin) {
              this.SignIn(emailData, password).then(res => {
                console.log(res);
                loadingEl.dismiss().then();
                resolve(true);
              }).catch((err) => {
                loadingEl.dismiss().then();
                this.showAlert(err);
                reject(err);
              });
            } else {
              this.SignUp(emailData, password).then(res => {
                console.log(res);
                switch (role) {
                      case 'admin': {
                        this.addAdmin({email: emailData}).then(addAdminProp => {
                          console.log(addAdminProp);
                          loadingEl.dismiss().then();
                          resolve(true);
                        }).catch(errAdminProp => {
                          loadingEl.dismiss().then();
                          this.showAlert(errAdminProp);
                          reject(errAdminProp);
                        });
                        break;
                      }
                      case 'expert': {
                        this.addExpert({email: emailData}).then(addExpertProp => {
                          console.log(addExpertProp);
                          loadingEl.dismiss().then();
                          resolve(true);
                        }).catch(errExpertProp => {
                          loadingEl.dismiss().then();
                          this.showAlert(errExpertProp);
                          reject(errExpertProp);
                        });
                        break;
                      }
                      case 'patient': {
                        this.addPatient({email: emailData}).then(addPatientProp => {
                          console.log(addPatientProp);
                          loadingEl.dismiss().then();
                          resolve(true);
                        }).catch(errPatientProp => {
                          loadingEl.dismiss().then();
                          this.showAlert(errPatientProp);
                          reject(errPatientProp);
                        });
                        break;
                      }
                      default: {
                        loadingEl.dismiss().then();
                        this.showAlert('Role Undefined');
                        reject(false);
                      }
                    }
              }).catch((err) => {
                loadingEl.dismiss().then();
                this.showAlert(err);
                reject(err);
              });
            }
          });
    });
  }

  showAlert(message: string) {
    this.alertCtrl
        .create({
          header: 'Authentication failed',
          message,
          buttons: ['Okay']
        })
        .then(alertEl => alertEl.present());
  }

  showAlertComplete(header: string, message: string, buttonText: string) {
    this.alertCtrl
        .create({
          header,
          message,
          buttons: [{
            text: buttonText
          }]
        })
        .then(alertEl => alertEl.present());
  }

  showAlertCompleteWithUrl(header: string, message: string, buttonText: string, url: any, params: NavigationExtras) {
    this.alertCtrl
        .create({
          header,
          message,
          buttons: [{
            text: buttonText,
            handler : (evt) => {
              console.log(evt);
              this.router.navigate([url], params).then();
            }
          }]
        })
        .then(alertEl => alertEl.present());
  }

  showAlertWithUrl(headerMessage: string, contentMessage: string, buttonText: string, url: string) {
    this.alertCtrl
        .create({
          header: headerMessage,
          message: contentMessage,
          buttons: [{
            text: buttonText,
            handler : (evt) => {
              console.log(evt);
              this.router.navigate([url]).then();
            }
          }]
        })
        .then(alertEl => alertEl.present());
  }

  async showToastMessage(message: string) {
      const toast = await this.toastController.create({
        message,
        duration: 2000
      });
      toast.present();

  }

  getActiveUserIdFirebaseAuth(): Promise<any> {
    return new Promise((resolve, reject) => {

      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          resolve(user.uid);
        }
      }).then().catch(err => {
        reject(err);
      });

/*      this.afAuth.currentUser.then(currentUser => {
        if (currentUser) {
          resolve(currentUser.uid);
        } else {
          console.log('please sign in! ');
        }
      }).catch(err => {
        reject(err);
      });*/
    });
  }

  getFirebaseUserForGuard(): Promise<any> {
    return new Promise((resolve, reject) => {

      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          resolve(user);
        }
      }).then().catch(() => {
        reject(false);
      });
    });
  }

  confirmStatusByAdmin(emailData: any): Promise<boolean> {
      return new Promise<boolean>((resolve, reject) => {
        this.confirmExpert({email: emailData}).then(res => {
          resolve(true);
        });
      });
  }
  reConfirmStatusByAdmin(emailData: any): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.reConfirmExpert({email: emailData}).then(res => {
        resolve(true);
      });
    });
}
}
